import { useEffect, useState, useCallback } from 'react';
import { fetchNotes } from 'store/redux/common/notes';
import { useAppDispatch } from 'store/redux/use-app-dispatch';

export function useNotes({
  sourceType,
  sourceIds,
}: {
  sourceType: string;
  // The ids go straight into the request body, and callers pass whatever the
  // source keys on — a recurrence's numeric id, a task's string uniqueId — so
  // this cannot narrow to one of them. `null` is the "nothing to fetch yet"
  // value the effect below already guards on.
  sourceIds?: (string | number | undefined)[] | null;
}) {
  // `useAppDispatch` rather than `useDispatch`: `clientMiddleware` resolves a
  // `promise` action to the client's result, which is what `setNotes` stores.
  const dispatch = useAppDispatch();
  const [notes, setNotes] = useState<any>();
  const [loading, setLoading] = useState(false);

  const init = useCallback(async () => {
    try {
      setLoading(true);

      const response = await dispatch(fetchNotes({ sourceType, sourceIds }));

      setNotes(response);
    } finally {
      setLoading(false);
    }
  }, [dispatch, sourceIds, sourceType]);

  useEffect(() => {
    if (sourceIds) {
      init();
    }
  }, [init, sourceIds]);

  return { notes, isLoadingNotes: loading, refetch: init };
}
